import { useAuthStore } from '@/stores/authStore';
import type { RouteLocationNormalizedLoaded } from 'vue-router';

/**
 * Does `route` host a cascade? A route may make that wait for a feature flag: the
 * dashboard and the video call are workspaces only for the appointment create column
 * (ADR-0048), so without `APPOINTMENT_SCHEDULING` their sidebars stay overlays.
 */
export const isWorkspaceRoute = (route: Pick<RouteLocationNormalizedLoaded, 'meta'>): boolean => {
  const { workspace, workspaceFeatureFlag } = route.meta ?? {};
  if (!workspace) return false;
  return !workspaceFeatureFlag || useAuthStore().isFeatureFlagEnabled(workspaceFeatureFlag);
};
